module.exports = __webpack_public_path__ + "img/galleria11.bbdaf279.jpg";